export const getWindowObject = () => {
	return typeof window !== 'undefined' && !!window ? window : undefined;
};

export const getPerformanceObject = () => {
	const { performance } = getWindowObject() || {};

	return performance;
};

export const getPerformanceObserverObject = () => {
	const { PerformanceObserver } = getWindowObject() || {};

	return PerformanceObserver;
};
